<div class="form-container">
  @if (submitting()) {
    <div class="onboarding-overlay">
      <div class="onboarding-overlay-content">
        <div class="onboarding-spinner"></div>
        <h2>Setting up your club...</h2>
        <p class="onboarding-progress-text">{{ progressMessage() }}</p>
      </div>
    </div>
  }

  <div class="form-card">
    <app-button label="Back" variant="text" color="primary" icon="pi pi-arrow-left" [fullWidth]="false"
      class="mb-3 d-inline-block" (clicked)="goBack()" [disabled]="submitting()">
    </app-button>

    <h2 class="mb-2 fs-4">Review &amp; Submit</h2>
    <p class="text-secondary mb-4 fs-6">Please review your details before final submission.</p>

    <!-- Admin Information -->
    <div class="review-section mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h3 class="fs-5 m-0">Account Information</h3>
        <app-button label="Edit" variant="text" size="sm" [fullWidth]="false" [disabled]="submitting()"
          (clicked)="router.navigate(['/auth/onboarding/create-account'])">
        </app-button>
      </div>
      <div class="review-grid shadow-sm p-3">
        <div class="review-item">
          <span class="review-label">Club Name</span>
          <span class="review-value">{{ adminInformation.clubName }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">Primary Activity</span>
          <span class="review-value">{{ adminInformation.primaryActivityName || adminInformation.primaryActivity }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">Contact Person</span>
          <span class="review-value">{{ adminInformation.contactPersonName }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">Email</span>
          <span class="review-value">{{ adminInformation.email }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">Phone</span>
          <span class="review-value">{{ adminInformation.phoneNumber }}</span>
        </div>
      </div>
    </div>

    <!-- Club Details -->
    <div class="review-section mb-4">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h3 class="fs-5 m-0">Club Details</h3>
        <app-button label="Edit" variant="text" size="sm" [fullWidth]="false" [disabled]="submitting()"
          (clicked)="goBack()">
        </app-button>
      </div>
      <div class="review-grid p-3">
        <div class="review-item full-width">
          <span class="review-label">Address</span>
          <span class="review-value">
            {{ clubInformation.clubAddress.address }}
            @if (clubInformation.clubAddress.address2) { , {{ clubInformation.clubAddress.address2 }} }
            <br>
            {{ clubInformation.clubAddress.city }}, {{ clubInformation.clubAddress.state }} {{ clubInformation.clubAddress.postCode }}<br>
            {{ clubInformation.clubAddress.countryName }}
          </span>
        </div>
        <div class="review-item">
          <span class="review-label">Currency</span>
          <span class="review-value">{{ clubInformation.currency }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">T&amp;C URL</span>
          <span class="review-value text-truncate d-inline-block" style="max-width: 100%;">{{ clubInformation.clubTnC }}</span>
        </div>
        <div class="review-item full-width mt-2">
          <span class="review-label">Club Logo</span>
          <div class="logo-preview mt-2">
            <img [src]="accountInformation.croppedImage || accountInformation.appIconUrl || 'assets/img/activitypro-logo.png'"
              alt="Club logo" width="90" height="90" style="object-fit: contain;" />
          </div>
        </div>
      </div>
    </div>

    <!-- Coach Details -->
    <div class="review-section mb-5">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h3 class="fs-5 m-0">Coach Details</h3>
        <app-button label="Edit" variant="text" size="sm" [fullWidth]="false" [disabled]="submitting()"
          (clicked)="goBack()">
        </app-button>
      </div>
      <div class="review-grid shadow-sm p-3">
        <div class="review-item">
          <span class="review-label">Name</span>
          <span class="review-value">{{ clubInformation.coachDetails.firstName }} {{ clubInformation.coachDetails.lastName }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">Email</span>
          <span class="review-value">{{ clubInformation.coachDetails.email }}</span>
        </div>
        <div class="review-item">
          <span class="review-label">Gender</span>
          <span class="review-value">{{ clubInformation.coachDetails.gender }}</span>
        </div>
      </div>
    </div>

    <!-- Terms and Conditions -->
    <div class="field mb-4">
      <div class="d-flex align-items-start gap-2">
        <p-checkbox inputId="terms" name="terms" [binary]="true"
          [ngModel]="clubInformation.termsAccepted"
          (ngModelChange)="clubInformation.termsAccepted = $event" />
        <label for="terms" class="fs-6">
          I agree to the
          <a href="https://www.activitypro.co.uk/terms-conditions/index.html" target="_blank" rel="noopener noreferrer" class="tc-link">Terms of Service</a>
          and acknowledge the
          <a href="https://www.activitypro.co.uk/privacy-policy.html" target="_blank" rel="noopener noreferrer" class="tc-link">Privacy Policy</a>.
        </label>
      </div>
    </div>

    <!-- Invisible reCAPTCHA -->
    <re-captcha #captchaRef size="invisible"
      (resolved)="onCaptchaResolved($event)"
      (error)="onCaptchaError($event)">
    </re-captcha>

    <div class="field">
      <app-button label="Submit &amp; Create Account" variant="filled" color="primary" [fullWidth]="true"
        class="w-100 d-block" [disabled]="submitting()" [loading]="submitting()"
        (clicked)="onSubmit()">
      </app-button>
    </div>
  </div>
</div>
